"use client";

import React from "react";

import FallbackUI from "./fallback";

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  message?: string;
}

interface State {
  hasError: boolean;
  error?: Error;
  isResetting: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      isResetting: false,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      isResetting: false,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  private resetError = async () => {
    this.setState({ isResetting: true });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <FallbackUI
          error={this.state.error}
          resetError={this.resetError}
          message={this.props.message}
          isResetting={this.state.isResetting}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
